import { usePremium } from '@/context/PremiumContext';

export default function useDestinsAvailability() {
  return usePremium().catalog?.availability?.destins === true;
}
